import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3H23V21H13V20.0039C13 13.9288 8.07513 9.00391 2 9.00391H1.00391L1 9V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 11H2C6.97056 11 11 15.0294 11 20V21H9V20C9 16.134 5.86599 13 2 13H1V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 15H2C4.76142 15 7 17.2386 7 20V21H5V20C5 18.3431 3.65685 17 2 17H1V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.00391 19H1V21.0039H3.00391V19Z"}}]};

const CastFilled = Vue.extend<IconProps>({
  name: 'CastFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cast-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CastFilled;
